/** HEADER **/


$( document ).ready(function() {
  $(".header-fix-cont .menu-item.has-submenu").mouseover(function(){
      $(this).addClass('is-expanded');
      $(".header-fix-cont .menu-item.has-submenu").not(this).removeClass('is-expanded');
  });

  $(".header-fix-cont .menu-item.has-submenu").mouseleave(function(){
      $(".header-fix-cont .menu-item.has-submenu").removeClass('is-expanded');
  });
  

  /** PRODUCT TABS **/

  $(".tab-title").click(function() {

      $(".tab-title").not($(this)).removeClass('is-active');
      $('.'+$('.tab-title:not(.is-active)').attr('id')).removeClass('is-active');
      $('.tab-content').removeClass('is-active');
      $(this).addClass('is-active');
      $('.'+$('.tab-title.is-active').attr('id')).addClass('is-active');
  });
  
});

$(".header__icons .searchToggle").click(function(e) {
    e.preventDefault();
    window.location = "https://www.goauntflow.com/search";
});

$("button.tab-title:contains('FAQ')").click(function(e) {
    e.preventDefault();
    window.location = "https://www.goauntflow.com/frequently-asked-questions";
});

$("button.tab-title:contains('Installation Guide')").click(function(e) {
    e.preventDefault();
    window.location = $('.tab-content').eq(1).text();
});

/****/

$(".logo__image").click(function(e) {
    e.preventDefault();
    window.location = "https://goauntflow.com/"
});


$("button.product__form-submit.custom-quote").text('get a custom quote') 

$(".custom-quote").click(function(e) {
    e.preventDefault();
    window.location = "https://goauntflow.typeform.com/to/TYILvEyG?utm_source=xxxxx&utm_medium=xxxxx&utm_campaign=xxxxx&utm_adgroup=xxxxx&utm_keyword=xxxxx&utm_creative=xxxxx ";
});

/** RECHARGE WIDGET TEMPLATE **/

$( document ).ready(function() {
  
  $(".rc_block.rc_block__type.rc_block__type__onetime.rc_block__type--active").addClass('selected')


  $("#rc_radio_options .rc_block").click(function() {
      $('#rc_radio_options .rc_block').removeClass('selected');
      $(this).addClass('selected');
      $(this).children('input').prop('checked', true);
  });
  
});
  

/** BOLD SHOP ALL LINK **/

$( document ).ready(function() {
  
 $( ".menu-item--meganav .submenu-item a:contains('Build Your Program')").addClass('build-program');
  
  $( ".menu-item--meganav .submenu-item a:contains('Shop All')").addClass('shop-all');
  
  $( ".menu-item--meganav .submenu-item a:contains('Display Box')").addClass('display');
  
  $( ".menu-item--meganav .submenu-item a:contains('Acrylic Box w/ Divider for  Tampons + Pads')").addClass('acrylic');
  
  $( ".menu-item--meganav .submenu-item a:contains('All Case Studies')").parent().addClass('red-offset'); 
  
  $( ".menu-item--meganav .submenu-item a:contains('A complete bathroom solution')").parent().addClass('red-offset'); 
  $( ".menu-item--meganav .submenu-item a:contains('Choose Your Bundle')").parent().addClass('red-offset'); 
  
  $(".nav-hamburger .menu-item.has-submenu>a:contains('About')").parent().addClass('about-mobile');
  
  $(".nav-hamburger .menu-item.has-submenu>a:contains('Products')").parent().addClass('products-mobile');
  
  $(".nav-hamburger .menu-item.has-submenu>a:contains('Resources')").parent().addClass('resource-mobile');
  
  $("a.submenu-item__link.visible-nav-link:contains('Add-Ons')").attr("href", "https://shop.goauntflow.com/collections/swag")
  $("a.submenu-item__link.visible-nav-link:contains('Add-Ons')").text('Swag')
  
  $(".submenu-item:not(.case-studies) a.submenu-item__link.visible-nav-link:contains('Case Studies')").addClass('case-studies-mobile');
  
  
  $("a.submenu-item__link.visible-nav-link:contains('Featured Case Studies')").parent().addClass('case-studies');
  $("a.submenu-item__link.visible-nav-link:contains('Featured Case Studies')").attr("href", "http://goauntflow.com/case-studies/ ")
  $("a.submenu-item__link.visible-nav-link:contains('Featured Case Studies')").text('Case Studies')
  
  

  /** TESTIMONIAL SLIDER **/
  
  var commentSlider = {
  
  'config' : {
    'container' : $('.testimonial-wrapper')
  },
    
  'init' : function(config) {
      if(config && typeof(config) == 'object') {
        $.extend(commentSlider.config, config);
      }
    
      //caching dom elements
      //wrapper
      commentSlider.$container = commentSlider.config.container;

      //all paragraph tags
      commentSlider.$paragraphs = commentSlider.$container.
        find('.t-slide');
    
      //all li tags
      commentSlider.$dots = commentSlider.$container.
        find('ul.dots-wrap > li');
    
      //first li within ul.dots-wrap
      commentSlider.$firstDot = commentSlider.$container.
        find('ul.dots-wrap > li:first-child');
    
      //first p tag within module wrapper
      commentSlider.$firstParagraph = commentSlider.$container.
        find('.t-slide:first-child');
      
      //setting first dot with .active class
      commentSlider.$firstDot.addClass('active');

      //setting first paragraph tag with .active class
      commentSlider.$firstParagraph.addClass('activeText');
    
      //initializing functions and defining their parameters
      commentSlider.currentItem(commentSlider.$paragraphs, commentSlider.$dots);
      commentSlider.setActiveDot(commentSlider.$dots);
      commentSlider.timer();
  },
  
    //timer function runs necesary functions every five seconds
    'timer' : function() {
      setInterval(function(){ 

      }, 5000);
    }, //timer function end

    //grabs current numerical class of dot clicked
    'dotNumber' : function($dot) {
      var dotClassArray = [];
      var dotClassList = dotClassArray.push($dot.attr('class'));
      var splitArray = dotClassArray.toString().split(' ');

      for(i = 0; i < splitArray.length; i++) {
        if (splitArray[i] === "dot") { 
          splitArray.splice(i, 1);
          var dotClickedNumber = splitArray[i];
          commentSlider.paragraphNumber(dotClickedNumber, commentSlider.$paragraphs);
        }
      }
    },//end dotNumber

    'paragraphNumber' : function(dotClickedNumber, $paragraphs) {
      $('.t-slide').each(function() {
          var $paragraph = $(this);
          var paragraphClass = $paragraph.attr('class');    

          if($($paragraph).hasClass(dotClickedNumber)) {          
            $paragraph.addClass('activeText');
            $paragraph.siblings('div').removeClass('activeText').addClass('slideLeft');
            setTimeout(function () { 
               $paragraph.siblings().removeClass('slideLeft');    
            }, 400);          
          }
      });
    },//end paragraphNumber

    //currentItem function gives every paragraph and dot a numerical class
    //based on their array position
    'currentItem' : function($paragraphs, $dots) {
      $paragraphs.each(function(i) {
        var $paragraph = $(this);
        $paragraph.addClass([] + i);
      });

      $dots.each(function(i) {
        var $dot = $(this);
        $dot.addClass([] + i);
      });
    },//end currentItem

    //setActiveDot adds class active to whichever dot is clicked
    'setActiveDot' : function($dots) {
      $dots.each( function() {
        var $dot = $(this);
        $dot.on('click', function() {
          if($dot.hasClass('active')) {
            return false;
          } else {
            $dot.addClass('active');
            $dot.siblings().removeClass('active');
          }
          commentSlider.dotNumber($dot);      
        });
      });
    }//end setActiveDot
  };

  //initializes the entire thing by calling the init function  
  $(document).ready(commentSlider.init);
  
  /** REMOVE EMPTY CHARACTERS **/
  
  $('p, h1, h2, h3, h4, h5').each(function() {
    if ($(this).text().trim().length == 0) {
        $(this).remove()
    }
  });
  
  /****/
  
   
});



